// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./$.export');

$export($export.P, 'Map', {toJSON: require('./$.collection-to-json')('Map')});


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/modules/es7.map.to-json.js
// module id = 749
// module chunks = 0